// extracted by mini-css-extract-plugin
export var heroImage = "_g1-1";
export var modal = "_g1-0";